// Libraries
import { MouseEventHandler } from 'react';

// Styles
import emojis from '../../../assets/data/emoji.json';

// Styles
import styles from './EmojiList.module.css';

/**
 * @function EmojiList
 * Describe the component's function
 *
 * @example
 * return (
 *   <EmojiList onClick={() => false} />
 * )
 */
function EmojiList({ onClick = () => false }: EmojiListProps): JSX.Element {
    return (
        <div className={styles.container}>
            <ul className={styles.list}>
                {emojis.map(({ emoji, description }) => (
                    <li>
                        <button
                            type="button"
                            value={emoji}
                            className={styles.button}
                            title={description}
                            onClick={(e) => onClick(e)}
                        >
                            {emoji}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}

/**
 * @interface EmojiListProps
 * Describes the properties required for the EmojiList component
 *
 * @property {MouseEvent} onClick
 */
export interface EmojiListProps {
    onClick?: MouseEventHandler<HTMLButtonElement>;
}

// Exports
export default EmojiList;
